import React from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import PromoEmbed from './PromoEmbed/PromoEmbed';
import LinkList from "./Statistik/LinkList";
import StatsPage from "./Statistik/StatsPage";
import LoginPage from "./LoginPage/LoginPage";

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<LoginPage/>}/>
                <Route path="/stats" element={<LinkList/>}/>
                <Route path="/stats/:id" element={<StatsPage/>}/>
                <Route path="/embed" element={<PromoEmbed/>}/>
            </Routes>
        </Router>
    );
}

export default App;
